import Dashboard from '__core/shared/model/dashboard/Dashboard';
import DashboardItem from '__core/shared/model/dashboard/DashboardItem';
import stDashboardWidget from './dashboardWidget.component';
import dashboardController from './dashboard.controller';

export default angular
  .module('st.Dashboard', ['st.Core'])
  .factory('Dashboard', () => Dashboard)
  .factory('DashboardItem', () => DashboardItem)
  .component('stDashboardWidget', stDashboardWidget)
  .controller('dashboardController', dashboardController)
  .service(
    'dashboardService',
    (
      $http,
      $rootScope,
      CacheFactory,
      dataService,
      Dashboard,
      Job,
      Note,
      Ticket,
      Contact,
      ReportStatusType,
      reportService,
      REPORT,
      DASHBOARD
    ) => {
      let cache;
      if (!CacheFactory.get(DASHBOARD.CACHE.NAME)) {
        cache = CacheFactory(DASHBOARD.CACHE.NAME, DASHBOARD.CACHE.STORE);
      }
      const cacheKey = (params, requestName) =>
        JSON.stringify({
          idAccount: $rootScope.CurrentAccount.id,
          idOrganization: $rootScope.CurrentOrganization.id,
          type: requestName || DASHBOARD.CACHE.NAME,
          params
        });

      return {
        createDashboard: (doc) => dataService.createDocument(Dashboard, doc),
        readDashboard: (doc) => dataService.readDocument(Dashboard, doc),
        updateDashboard: (doc) => dataService.updateDocument(Dashboard, doc),
        deleteDashboard: (doc) => dataService.deleteDocument(Dashboard, doc),
        clearCache: () => cache.removeAll(),
        getWidgets: () => {
          const w = [];
          let object;
          const objectReduced = [];
          if ($rootScope.IsEnterprise) {
            if ($rootScope.CurrentOrganization.isBranch()) {
              object = reportService.quickObjectsForEnterpriseBranch();
            } else if ($rootScope.CurrentOrganization.isGroup()) {
              object = reportService.quickObjectsForEnterpriseGroup();
              objectReduced.push({
                key: 'object.group',
                name: 'Group',
                fields: ['organization.groupName'],
                aggregations: [{ term: 'relOrganization.groupName', type: 'aggGroup' }]
              });
            } else {
              object = Object.assign([], REPORT.QUICK.OBJECTS);
              objectReduced.push({
                key: 'object.enterprise',
                name: 'Enterprise',
                fields: ['organization.enterpriseName'],
                aggregations: [
                  {
                    term: 'relOrganization.enterpriseName',
                    type: 'aggEnterprise'
                  }
                ]
              });
            }
          } else {
            object = reportService.quickObjectsForOrganization();
          }
          objectReduced.push({
            key: 'object.organization',
            name: 'Organization',
            fields: ['organization.name'],
            filters: [
              {
                term: 'idOrganization',
                type: 'string',
                value: $rootScope.CurrentOrganization.id
              }
            ],
            aggregations: [
              { term: 'relOrganization.organization.name', type: 'aggOrganization' }
            ]
          });
          objectReduced.push({
            key: 'object.user',
            name: 'User',
            fields: ['deal.owner.nameFull'],
            filters: [
              {
                term: 'idOwner',
                type: 'string',
                value: $rootScope.CurrentAccount.id
              }
            ],
            aggregations: [
              {
                term: 'idOwner',
                type: 'aggAccount'
              }
            ]
          });

          const statusExpected = {
            key: 'status.expected',
            rel: 'EXPECTED',
            name: 'Expected',
            fields: ['aggregation.deal.expected.{valueType}']
          };

          const afWidgets = [
            { name: 'Net Amount Financed', key: 'afnaf' },
            { name: 'Broker Commission Value', key: 'afbcv' },
            { name: 'Broker Origination Fee', key: 'afbof' },
            { name: 'Total Brokerage', key: 'aftb' }
          ];

          const status = REPORT.QUICK.STATUSES;
          const time = REPORT.QUICK.TIME;
          const values = REPORT.QUICK.VALUES;
          const anniv = REPORT.QUICK.ANNIVERSARY;
          //
          // LEADERBOARD WIDGETS
          //
          _.forEach(object, (o) => {
            _.forEach(status, (s) => {
              _.forEach(
                _.reject(
                  time,
                  (t) => t.key.indexOf('time.next') > -1 || t.key.indexOf('time.any') > -1
                ),
                (t) => {
                  const rst = ReportStatusType.of(s.rel);
                  const widget = (af) => ({
                    group: {
                      name: `Leaderboard - ${o.name} - ${s.name}${af ? ' - ' + af.name : ''}`,
                      section: 'Leaderboard',
                      object: o.name,
                      status: s.name
                    },
                    name: `${o.name}, ${s.name}, ${t.name}${af ? ' (' + af.name + ')' : ''}`,
                    key: `BARS.${o.key}.${s.key}.${t.key}${
                      af ? '.' + af.key : ''
                    }`.toUpperCase(),
                    dim: [1, 1],
                    min: [1, 1],
                    report: {
                      isQuick: true,
                      quick: { isLeaderBoard: true },
                      aggregations: o.aggregations,
                      filters: [
                        {
                          nest: rst.path,
                          bool: rst.path ? 'must' : undefined,
                          term: rst.prop,
                          type: 'boolean',
                          value: 'true'
                        },
                        {
                          nest: rst.path,
                          bool: rst.path ? 'must' : undefined,
                          term: t.filters[0].term,
                          type: t.filters[0].type,
                          value: t.filters[0].value
                        },
                        {
                          term: 'isActive',
                          type: 'boolean',
                          value: 'true'
                        }
                      ],
                      fields: []
                        .concat(o.fields)
                        .concat(
                          s.fields[0].replace('{valueType}', af ? `${af.key}.sum` : 'sum')
                        )
                    }
                  });
                  w.push(widget());
                  _.forEach(afWidgets, (af) => w.push(widget(af)));
                }
              );
            });
          });
          //
          // PIPELINE WIDGETS
          //
          _.forEach(objectReduced, (o) => {
            _.forEach(
              _.reject(
                time,
                (t) => t.key.indexOf('time.next') > -1 || t.key.indexOf('time.any') > -1
              ),
              (t) => {
                w.push({
                  group: {
                    name: `Pipeline - ${o.name}`,
                    section: 'Pipeline',
                    object: o.name
                  },
                  name: `${o.name}, ${t.name}`,
                  key: `CHART.STACKED.${o.key}.${t.key}`.toUpperCase(),
                  dim: [1, 1],
                  min: [1, 1],
                  report: {
                    isQuick: true,
                    quick: { isPipeline: true },
                    aggregations: o.aggregations,
                    filters: [
                      {
                        term: '{timeStampTerm}',
                        type: 'date',
                        value: t.filters[0].value
                      },
                      {
                        term: 'isActive',
                        type: 'boolean',
                        value: 'true'
                      }
                    ].concat(o.filters),
                    fields: []
                      .concat(o.fields)
                      .concat([
                        'aggregation.deal.created.sum',
                        'aggregation.deal.submitted.sum',
                        'aggregation.deal.approved.sum',
                        'aggregation.deal.settled.sum'
                      ])
                  }
                });
              }
            );
          });
          //
          // CONVERSION WIDGETS
          //
          _.forEach(objectReduced, (o) => {
            _.forEach(
              _.reject(status, (s) => s.rel === 'SETTLED'),
              (s) => {
                _.forEach(
                  _.reject(
                    time,
                    (t) => t.key.indexOf('time.next') > -1 || t.key.indexOf('time.any') > -1
                  ),
                  (t) => {
                    const rst = ReportStatusType.of(s.rel);
                    w.push({
                      group: {
                        name: `Conversion - ${o.name} - ${s.name}`,
                        section: 'Conversion',
                        object: o.name,
                        status: s.name
                      },
                      name: `${o.name}, ${t.name}, ${s.name}`,
                      key: `CHART.GAUGE.${o.key}.${t.key}.${s.key}`.toUpperCase(),
                      dim: [1, 1],
                      min: [1, 1],
                      report: {
                        isQuick: true,
                        quick: { isConversion: true },
                        aggregations: o.aggregations,
                        filters: [
                          {
                            term: '{timeStampTerm}',
                            type: 'date',
                            value: t.filters[0].value
                          },
                          {
                            term: 'isActive',
                            type: 'boolean',
                            value: 'true'
                          }
                        ].concat(o.filters),
                        fields: []
                          .concat(o.fields)
                          .concat(s.fields[0].replace('{valueType}', 'sum'))
                      }
                    });
                  }
                );
              }
            );
          });
          //
          // STATS WIDGETS
          //
          _.forEach(objectReduced, (o) => {
            _.forEach(status, (s) => {
              _.forEach(
                _.reject(
                  time,
                  (t) => t.key.indexOf('time.next') > -1 || t.key.indexOf('time.any') > -1
                ),
                (t) => {
                  const rst = ReportStatusType.of(s.rel);
                  const widget = (af) => ({
                    group: {
                      name: `Statistics - ${o.name} - ${s.name}${af ? ' - ' + af.name : ''}`,
                      section: 'Statistics',
                      object: o.name,
                      status: s.name
                    },
                    name: `${o.name}, ${t.name}, ${s.name}${af ? ' (' + af.name + ')' : ''}`,
                    key: `STATS.${o.key}.${t.key}.${s.key}${
                      af ? '.' + af.key : ''
                    }`.toUpperCase(),
                    dim: [1, 1],
                    min: [1, 1],
                    report: {
                      isQuick: true,
                      quick: { isPipeline: true },
                      aggregations: o.aggregations,
                      filters: [
                        {
                          term: '{timeStampTerm}',
                          type: 'date',
                          value: t.filters[0].value
                        },
                        {
                          term: 'isActive',
                          type: 'boolean',
                          value: 'true'
                        }
                      ].concat(o.filters),
                      fields: []
                        .concat(o.fields)
                        .concat(
                          s.fields[0].replace('{valueType}', af ? `${af.key}.sum` : 'sum')
                        )
                        .concat(
                          s.fields[0].replace('{valueType}', af ? `${af.key}.count` : 'count')
                        )
                    }
                  });
                  w.push(widget());
                  _.forEach(afWidgets, (af) => w.push(widget(af)));
                }
              );
            });
            _.forEach([statusExpected], (s) => {
              _.forEach(
                _.reject(
                  time,
                  (t) => t.key.indexOf('time.last') > -1 || t.key.indexOf('time.any') > -1
                ),
                (t) => {
                  const rst = ReportStatusType.of(s.rel);
                  w.push({
                    group: {
                      name: `Statistics - ${o.name} - ${s.name}`,
                      section: 'Statistics',
                      object: o.name,
                      status: s.name
                    },
                    name: `${o.name}, ${t.name}, ${s.name}`,
                    key: `STATS.${o.key}.${t.key}.${s.key}`.toUpperCase(),
                    dim: [1, 1],
                    min: [1, 1],
                    report: {
                      isQuick: true,
                      quick: { isPipeline: true },
                      aggregations: o.aggregations,
                      filters: [
                        {
                          term: '{timeStampTerm}',
                          type: 'date',
                          value: t.filters[0].value
                        },
                        {
                          term: 'isActive',
                          type: 'boolean',
                          value: 'true'
                        }
                      ].concat(o.filters),
                      fields: []
                        .concat(o.fields)
                        .concat(s.fields[0].replace('{valueType}', 'sum'))
                        .concat(s.fields[0].replace('{valueType}', 'count'))
                    }
                  });
                }
              );
            });
          });
          //
          // TIME WIDGETS
          //
          _.forEach(objectReduced, (o) => {
            _.forEach(status, (s) => {
              _.forEach(
                _.reject(
                  time,
                  (t) => t.key.indexOf('time.next') > -1 || t.key.indexOf('time.any') > -1
                ),
                (t) => {
                  const rst = ReportStatusType.of(s.rel);
                  w.push({
                    group: {
                      name: `Time breakdown - ${o.name} - ${s.name}`,
                      section: 'Time breakdown',
                      object: o.name,
                      status: s.name
                    },
                    name: `${o.name}, ${t.name}, ${s.name}`,
                    key: `CHART.STACKED.${o.key}.${t.key}.${s.key}`.toUpperCase(),
                    dim: [1, 1],
                    min: [1, 1],
                    report: {
                      isQuick: true,
                      quick: { isLeaderBoard: true },
                      aggregations: o.aggregations,
                      filters: [
                        {
                          nest: rst.path,
                          bool: rst.path ? 'must' : undefined,
                          term: rst.prop,
                          type: 'boolean',
                          value: 'true'
                        },
                        {
                          nest: rst.path,
                          bool: rst.path ? 'must' : undefined,
                          term: t.filters[0].term,
                          type: t.filters[0].type,
                          value: t.filters[0].value
                        },
                        {
                          term: 'isActive',
                          type: 'boolean',
                          value: 'true'
                        }
                      ].concat(o.filters),
                      fields: []
                        .concat(o.fields)
                        .concat(
                          _.map(
                            t.fieldsMap,
                            (tm) => `${s.fields[0].replace('{valueType}', 'sum')}.${tm}`
                          )
                        )
                    }
                  });
                }
              );
            });
            _.forEach([statusExpected], (s) => {
              _.forEach(
                _.reject(
                  time,
                  (t) => t.key.indexOf('time.last') > -1 || t.key.indexOf('time.any') > -1
                ),
                (t) => {
                  const rst = ReportStatusType.of(s.rel);
                  w.push({
                    group: {
                      name: `Time breakdown - ${o.name} - ${s.name}`,
                      section: 'Time breakdown',
                      object: o.name,
                      status: s.name
                    },
                    name: `${o.name}, ${t.name}, ${s.name}`,
                    key: `CHART.STACKED.${o.key}.${t.key}.${s.key}`.toUpperCase(),
                    dim: [1, 1],
                    min: [1, 1],
                    report: {
                      isQuick: true,
                      quick: { isLeaderBoard: true },
                      aggregations: o.aggregations,
                      filters: [
                        {
                          nest: rst.path,
                          bool: rst.path ? 'must' : undefined,
                          term: rst.prop,
                          type: 'boolean',
                          value: 'true'
                        },
                        {
                          nest: rst.path,
                          bool: rst.path ? 'must' : undefined,
                          term: t.filters[0].term,
                          type: t.filters[0].type,
                          value: t.filters[0].value
                        },
                        {
                          term: 'isActive',
                          type: 'boolean',
                          value: 'true'
                        }
                      ].concat(o.filters),
                      fields: []
                        .concat(o.fields)
                        .concat(
                          _.map(
                            t.fieldsMap,
                            (tm) => `${s.fields[0].replace('{valueType}', 'sum')}.${tm}`
                          )
                        )
                    }
                  });
                }
              );
            });
          });
          //
          // DEALS LIST
          //
          _.forEach(status, (s) => {
            _.forEach(
              _.reject(
                time,
                (t) => t.key.indexOf('time.next') > -1 || t.key.indexOf('time.any') > -1
              ),
              (t) => {
                const rst = ReportStatusType.of(s.rel);
                w.push({
                  group: { name: `Deal - ${s.name}`, section: 'Deal', status: s.name },
                  name: `Deal ${s.name}, ${t.name}`,
                  key: `REPORT.TICKET.${s.key}.${t.key}`.toUpperCase(),
                  dim: [1, 1],
                  min: [1, 1],
                  report: {
                    isQuick: true,
                    quick: { isTicket: true },
                    filters: [
                      {
                        nest: rst.path,
                        bool: rst.path ? 'must' : undefined,
                        term: rst.propTime,
                        type: t.filters[0].type,
                        value: t.filters[0].value
                      },
                      {
                        nest: rst.path,
                        bool: rst.path ? 'must' : undefined,
                        term: rst.prop,
                        type: 'boolean',
                        value: 'true'
                      },
                      {
                        term: 'isActive',
                        type: 'boolean',
                        value: 'true'
                      }
                    ],
                    fields: [].concat([
                      'deal.id',
                      'deal.idWorkflow',
                      'deal.name',
                      'deal.value',
                      'organization.name',
                      'workflow.name'
                    ])
                  }
                });
              }
            );
          });
          //
          // PRODUCT LIST
          //
          _.forEach(status, (s) => {
            _.forEach(
              _.reject(
                time,
                (t) => t.key.indexOf('time.next') > -1 || t.key.indexOf('time.any') > -1
              ),
              (t) => {
                const rst = ReportStatusType.of(s.rel);
                w.push({
                  group: { name: `Product - ${s.name}`, section: 'Product', status: s.name },
                  name: `Product ${s.name}, ${t.name}`,
                  key: `REPORT.PRODUCT.${s.key}.${t.key}`.toUpperCase(),
                  dim: [1, 1],
                  min: [1, 1],
                  report: {
                    isQuick: true,
                    quick: { isTicket: true },
                    filters: [
                      {
                        nest: rst.path,
                        bool: rst.path ? 'must' : undefined,
                        term: rst.propTime,
                        type: t.filters[0].type,
                        value: t.filters[0].value
                      },
                      {
                        nest: rst.path,
                        bool: rst.path ? 'must' : undefined,
                        term: rst.prop,
                        type: 'boolean',
                        value: 'true'
                      },
                      {
                        term: 'isActive',
                        type: 'boolean',
                        value: 'true'
                      }
                    ],
                    fields: [].concat([
                      'deal.id',
                      'deal.idWorkflow',
                      'deal.name',
                      'deal.value',
                      'deal.loan.lender',
                      'deal.loan.details.loanSplit1.product',
                      'deal.loan.details.loanSplit2.product',
                      'deal.loan.details.loanSplit3.product',
                      'deal.loan.details.loanSplit4.product',
                      'deal.loan.details.loanSplit5.product',
                      'deal.loan.details.loanSplit6.product',
                      'deal.loan.details.loanSplit7.product',
                      'deal.loan.details.loanSplit8.product',
                      'deal.loan.details.loanSplit9.product',
                      'deal.loan.details.loanSplit10.product',
                      'organization.name',
                      'workflow.name'
                    ])
                  }
                });
              }
            );
          });
          //
          // ANNIVERSARIES LIST
          //
          _.forEach(
            _.reject(anniv, (a) => a.key === 'anniversary.none'),
            (a) => {
              _.forEach(
                _.reject(
                  time,
                  (t) => t.key.indexOf('time.last') > -1 || t.key.indexOf('time.any') > -1
                ),
                (t) => {
                  w.push({
                    group: {
                      name: `Anniversary - ${a.name}`,
                      section: 'Anniversary',
                      object: a.name
                    },
                    name: `${a.name}, ${t.name}`,
                    key: `REPORT.ANNIVERSARY.${a.key}.${t.key}`.toUpperCase(),
                    dim: [1, 1],
                    min: [1, 1],
                    report: {
                      isQuick: true,
                      quick: { isContacts: true },
                      aggregations: [],
                      filters: t.filters.concat(a.filters).concat([
                        {
                          term: 'isActive',
                          type: 'boolean',
                          value: 'true'
                        }
                      ]),
                      fields: a.fields.concat('id', 'avatar', 'isCompany')
                    }
                  });
                }
              );
            }
          );
          return w.concat(DASHBOARD.LISTS);
        },
        getTopTickets: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params, 'getTopTickets'),
            params?.ignoreCache === true,
            Ticket.build,
            $http.get,
            DASHBOARD.API.TOP_DEALS_USER,
            { params }
          ),
        getTopNotes: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params, 'getTopNotes'),
            params?.ignoreCache === true,
            Note.build,
            $http.get,
            DASHBOARD.API.TOP_NOTES_USER,
            { params }
          ),
        getTopJobs: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params, 'getTopJobs'),
            params?.ignoreCache === true,
            Job.build,
            $http.get,
            DASHBOARD.API.TOP_JOBS_USER,
            { params }
          ),
        getTopContacts: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params, 'getTopContacts'),
            params?.ignoreCache === true,
            Contact.build,
            $http.get,
            DASHBOARD.API.TOP_CONTACTS_USER,
            { params }
          )
      };
    }
  )
  .constant('DASHBOARD', {
    DEFAULT: {
      name: 'Default dashboard',
      items: [
        {
          dim: [1, 1],
          key: 'CHART.GAUGE.OBJECT.USER.TIME.LAST12MONTHS.STATUS.OPEN',
          loc: [0, 0],
          max: [],
          min: [1, 1],
          name: 'User, Previous 12 months, Created'
        },
        {
          dim: [1, 1],
          key: 'BARS.OBJECT.USER.STATUS.SETTLED.TIME.LASTMONTH',
          loc: [1, 0],
          max: [],
          min: [1, 1],
          name: 'User, Settled, Previous Month'
        },
        {
          dim: [1, 1],
          key: 'STATS.OBJECT.USER.TIME.LASTMONTH.STATUS.SETTLED',
          loc: [2, 0],
          max: [],
          min: [1, 1],
          name: 'User, Previous Month, Settled'
        },
        {
          dim: [1, 1],
          key: 'STATS.OBJECT.USER.TIME.THISMONTH.STATUS.SETTLED',
          loc: [3, 0],
          max: [],
          min: [1, 1],
          name: 'User, This Month, Settled'
        },
        {
          dim: [1, 1],
          key: 'STATS.OBJECT.USER.TIME.THISMONTH.STATUS.OPEN',
          loc: [4, 0],
          max: [],
          min: [1, 1],
          name: 'User, This Month, Created'
        },
        {
          dim: [3, 2],
          key: 'CHART.STACKED.OBJECT.USER.TIME.LASTMONTH',
          loc: [0, 1],
          max: [],
          min: [1, 1],
          name: 'User, Previous Month'
        },
        {
          dim: [3, 2],
          key: 'CHART.STACKED.OBJECT.USER.TIME.LAST12MONTHS.STATUS.SETTLED',
          loc: [3, 1],
          max: [],
          min: [1, 1],
          name: 'User, Previous 12 months, Settled'
        },
        {
          dim: [1, 1],
          key: 'REPORT.ANNIVERSARY.ANNIVERSARY.DOB.TIME.THISMONTH',
          loc: [],
          max: [],
          min: [1, 1],
          name: 'Birthday, This Month'
        }
      ]
    },
    LISTS: [
      {
        group: {
          name: `List - Latest Deals`,
          section: 'List',
          object: 'Deals',
          status: ''
        },
        name: 'Deals, latest',
        key: 'LIST.DEALS.LATEST',
        dim: [1, 1],
        min: [1, 1],
        pluck: [],
        criteria: 'latest'
      },
      {
        group: {
          name: `List - Latest Deals - Won`,
          section: 'List',
          object: 'Deals',
          status: 'Won'
        },
        name: 'Deals, latest won',
        key: 'LIST.DEALS.WON',
        dim: [1, 1],
        min: [1, 1],
        pluck: [],
        criteria: 'won'
      },
      {
        group: {
          name: `List - Latest Deals - Lost`,
          section: 'List',
          object: 'Deals',
          status: 'Lost'
        },
        name: 'Deals, latest lost',
        key: 'LIST.DEALS.LOST',
        dim: [1, 1],
        min: [1, 1],
        pluck: [],
        criteria: 'lost'
      },
      {
        group: {
          name: `List - Latest Deals - Most valuable`,
          section: 'List',
          object: 'Deals',
          status: 'Most valuable'
        },
        name: 'Deals, most valuable',
        key: 'LIST.DEALS.VALUE',
        dim: [1, 1],
        min: [1, 1],
        pluck: [],
        criteria: 'valuable'
      },
      {
        group: {
          name: `List - Latest Notes`,
          section: 'List',
          object: 'Notes',
          status: ''
        },
        name: 'Notes, latest',
        key: 'LIST.NOTES.USER',
        dim: [1, 1],
        min: [1, 1],
        pluck: [],
        criteria: 'latest'
      },
      {
        group: {
          name: `List - Latest Tasks`,
          section: 'List',
          object: 'Tasks',
          status: ''
        },
        name: 'Tasks, latest',
        key: 'LIST.JOBS.LATEST',
        dim: [1, 1],
        min: [1, 1],
        pluck: [],
        criteria: 'latest'
      },
      {
        group: {
          name: `List - Latest Tasks - Due`,
          section: 'List',
          object: 'Tasks',
          status: 'Due'
        },
        name: 'Tasks, due ',
        key: 'LIST.JOBS.DUE',
        dim: [1, 1],
        min: [1, 1],
        pluck: [],
        criteria: 'due'
      },
      {
        group: {
          name: `List - Latest Tasks - Overdue`,
          section: 'List',
          object: 'Tasks',
          status: 'Overdue'
        },
        name: 'Tasks, overdue',
        key: 'LIST.JOBS.OVERDUE',
        dim: [1, 1],
        min: [1, 1],
        pluck: [],
        criteria: 'overdue'
      },
      {
        group: {
          name: `List - Latest Contacts`,
          section: 'List',
          object: 'Contacts',
          status: ''
        },
        name: 'Contacts, latest',
        key: 'LIST.CONTACTS.LATEST',
        dim: [1, 1],
        min: [1, 1],
        pluck: [],
        criteria: 'latest'
      }
    ],
    API: {
      TOP_DEALS_USER: '/api/v1/dashboard/top-deals/',
      TOP_NOTES_USER: '/api/v1/dashboard/top-notes/',
      TOP_JOBS_USER: '/api/v1/dashboard/top-jobs/',
      TOP_CONTACTS_USER: '/api/v1/dashboard/top-contacts/'
    },
    CACHE: {
      NAME: 'dashboardCache',
      STORE: {
        maxAge: 1 * 1000,
        deleteOnExpire: 'aggressive',
        recycleFreq: 30 * 1000,
        storageMode: 'sessionStorage'
      }
    }
  });
